import React from 'react';

export const FilePdf = () => (
    <>
        <path d='M14 3v4a1 1 0 0 0 1 1h4' />
        <path d='M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z' />
        <line x1='9' y1='9' x2='10' y2='9' />
        <line x1='9' y1='13' x2='15' y2='13' />
        <line x1='9' y1='17' x2='15' y2='17' />
    </>
);